(() => {
  if (window.BlendRebuySmartCart) return;

  const ROOT_ATTRIBUTE = 'data-blend-rebuy-smart-cart';
  const ACTIVE_VALUE = 'active';

  let active = false;
  let pendingShow = false;
  let lastTrigger;

  const nativeCartDrawer = () => document.getElementById('site-cart-sidebar');

  const cartTriggers = () => document.querySelectorAll('[aria-controls="site-cart-sidebar"]');

  const setTriggerState = expanded => {
    cartTriggers().forEach(trigger => {
      trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  };

  const dispatch = (name, detail = {}) => {
    document.dispatchEvent(new CustomEvent(`blend:rebuy-smart-cart:${name}`, { detail }));
  };

  const smartCartIsReady = () => (
    window.Rebuy?.SmartCart?.status === 'ready'
    && typeof window.Rebuy.SmartCart.show === 'function'
    && typeof window.Rebuy.SmartCart.hide === 'function'
  );

  const closeNativeCart = () => {
    const drawer = nativeCartDrawer();
    if (!drawer || typeof drawer.hide !== 'function') return;

    if (drawer.opened || drawer.classList.contains('sidebar--opened')) {
      drawer.hide();
      drawer.setAttribute('aria-hidden', 'true');
      drawer.style.display = 'none';
    }
  };

  const restoreFocus = () => {
    if (!lastTrigger?.isConnected) {
      lastTrigger = null;
      return;
    }

    const focusedElement = document.activeElement;
    if (
      !focusedElement
      || focusedElement === document.body
      || focusedElement.closest?.('.rebuy-cart')
    ) {
      lastTrigger.focus();
    }

    lastTrigger = null;
  };

  const failSafely = error => {
    const openNativeCart = pendingShow;

    active = false;
    pendingShow = false;
    document.documentElement.removeAttribute(ROOT_ATTRIBUTE);
    setTriggerState(false);
    dispatch('error', { error });

    if (openNativeCart) {
      const drawer = nativeCartDrawer();
      if (drawer && typeof drawer.show === 'function') drawer.show();
    }
  };

  const showWhenReady = () => {
    if (!active || !pendingShow || !smartCartIsReady()) return false;

    try {
      window.Rebuy.SmartCart.show();
      pendingShow = false;
      setTriggerState(true);
      return true;
    } catch (error) {
      failSafely(error);
      return false;
    }
  };

  const enable = ({ source = 'rebuy-ready' } = {}) => {
    if (!smartCartIsReady()) return false;

    if (!active) {
      active = true;
      document.documentElement.setAttribute(ROOT_ATTRIBUTE, ACTIVE_VALUE);
      closeNativeCart();
      dispatch('activate', { source });
    }

    showWhenReady();
    dispatch('ready', { source });
    return active;
  };

  const show = () => {
    const focusedElement = document.activeElement;
    if (focusedElement instanceof HTMLElement && focusedElement !== document.body) {
      lastTrigger = focusedElement;
    }

    pendingShow = true;
    setTriggerState(true);

    if (!enable({ source: 'cart-open' })) {
      pendingShow = false;
      setTriggerState(false);
      return false;
    }

    return true;
  };

  const hide = () => {
    pendingShow = false;
    setTriggerState(false);
    if (smartCartIsReady()) window.Rebuy.SmartCart.hide();
  };

  window.BlendRebuySmartCart = {
    hide,
    isActive: () => active && smartCartIsReady(),
    show
  };

  document.addEventListener('rebuy:smartcart.ready', () => {
    enable({ source: 'rebuy-ready' });
  });
  document.addEventListener('rebuy:smartcart.show', () => setTriggerState(true));
  document.addEventListener('rebuy:smartcart.hide', () => {
    setTriggerState(false);
    restoreFocus();
  });

  enable({ source: 'existing-ready' });
})();
